import { components } from 'react-select';
import { withClassName } from '../helpers';
export const GenericSelectControlSingleValue = withClassName(components.SingleValue, 'singleValue');